export const buddhaRu: Record<string, string> = {
  "hud.mana": "КАРМА (ЖИЗНЬ)",
  "hud.blessing": "ЗАСЛУГА",
  "hud.chapelCost": "Ступа: {{cost}} кармы",
  "hud.wallCost": "Граница: {{cost}} кармы",
  "hud.amplifierCost": "Певчий: {{cost}} кармы",
  "hud.trapCost": "Силок: {{cost}} кармы",
  "hud.shrineCost": "Святилище колеса: {{cost}} кармы",
  "hud.relicCost": "Мантра: {{cost}} кармы",
  "hud.modeTower": "Ступа",
  "hud.modeWall": "Граница",
  "hud.modeAmp": "Певчий",
  "hud.modeTrap": "Силок",
  "hud.modeShrine": "Святилище колеса",
  "hud.mobType.Normal": "Голодные тени",
  "hud.mobType.Swarm": "Беспокойные искры",
  "hud.mobType.Armored": "Железные привязки",
  "hud.mobType.Giant": "Узники колеса",
  "hud.mobType.Runner": "Беглые желания",
  "hud.hint.clickGround": "По земле - ступа",
  "hud.hint.keys": "1-8 - создать мантру",
  "hud.hint.clickChapel": "По ступе - вложить мантру",
  "hud.prepSpace": "Пробел или Волна 1 - начать обряд",
  "hud.inventory": "Мантры:",
  "hud.noRelics": "Нет мантр (1-8 чтобы создать)",
  "hud.priest": "Монах Ур. {{level}}",
  "hud.grace": "Карма {{grace}}",
  "hud.relics": "МАНТРЫ",
  "hud.actionSanctify": "Уточнить",
  "hud.buildChapel": "Ступа",
  "hud.buildWall": "Граница",
  "hud.buildAmplifier": "Певчий",
  "hud.buildTrap": "Силок",
  "hud.buildShrine": "Святилище колеса",
  "hud.upgradeCost": "Цена уточнения: {{cost}}",
  "map.launchCta": "Начать обряд",
  "map.startDefense": "Начать обряд",
  "settings.title": "Обряд — {{field}}",
  "settings.begin": "Начать обряд",

  "skills.title": "Практики",
  "skills.grace": "Свободно: {{n}} / {{total}}",
  "skills.button": "Практики [S]",
  "buddha.skill.0": "Стартовая карма",
  "buddha.skill.1": "Поток кармы",
  "buddha.skill.2": "Цена возврата",
  "buddha.skill.3": "Дешёвые мантры",
  "buddha.skill.4": "Дешёвые постройки",
  "buddha.skill.5": "Разбор построек",
  "buddha.skill.6": "Зелёное пламя",
  "buddha.skill.7": "Красная решимость",
  "buddha.skill.8": "Сила взрыва",
  "buddha.skill.9": "Оранжевый гром",
  "buddha.skill.10": "Лаймовая цепь",
  "buddha.skill.11": "Сила певчего",
  "buddha.skill.12": "Глубокий запас кармы",
  "buddha.skill.13": "Двойная мантра",
  "buddha.skill.14": "Удачная мантра",
  "buddha.skill.15": "Фиолетовая тишина",
  "buddha.skill.16": "Синее отсечение",
  "buddha.skill.17": "Святилища колеса",
  "buddha.skill.18": "Бирюзовый шок",
  "buddha.skill.19": "Жёлтый сбор",
  "buddha.skill.20": "Силки",
  "buddha.skill.21": "Урон мантр",
  "buddha.skill.22": "Первая дикая мантра",
  "buddha.skill.23": "Быстрая установка",
  "buddha.skill.24": "Частые залпы",
  "buddha.skill.25": "Широкий охват",
  "buddha.skill.26": "Метки в карму",
  "buddha.skill.desc.0": "Больше кармы и больший запас жизни в начале каждой защиты.",
  "buddha.skill.desc.1": "Карма восстанавливается быстрее и чаще возвращается за побеждённых врагов.",
  "buddha.skill.desc.2": "Меньше кармы тратится, когда враг дошёл до ступицы и его надо вернуть.",
  "buddha.skill.desc.3": "Дешевле создавать и сливать мантры.",
  "buddha.skill.desc.4": "Дешевле строить ступы, границы, певчих, силки и святилища.",
  "buddha.skill.desc.5": "Больше кармы возвращается при разборе постройки.",
  "buddha.skill.desc.6": "Зелёные мантры жгут дольше и сильнее.",
  "buddha.skill.desc.7": "Красные мантры дают более сильные критические удары.",
  "buddha.skill.desc.8": "Взрывы мантр наносят больше урона по площади.",
  "buddha.skill.desc.9": "Оранжевые мантры лучше бьют группы врагов.",
  "buddha.skill.desc.10": "Лаймовые мантры сильнее перескакивают между целями.",
  "buddha.skill.desc.11": "Певчие сильнее поддерживают соседние ступы.",
  "buddha.skill.desc.12": "Запас кармы расширяется дешевле.",
  "buddha.skill.desc.13": "Двухцветные мантры сохраняют больше силы обоих эффектов.",
  "buddha.skill.desc.14": "Новые мантры чаще появляются повышенного грейда.",
  "buddha.skill.desc.15": "Фиолетовые мантры дольше удерживают врагов в тишине.",
  "buddha.skill.desc.16": "Синие мантры сильнее снимают броню и сопротивление.",
  "buddha.skill.desc.17": "Святилища колеса выпускают более сильный накопленный заряд.",
  "buddha.skill.desc.18": "Бирюзовые мантры надёжнее накладывают шок.",
  "buddha.skill.desc.19": "Жёлтые мантры возвращают больше кармы с попаданий.",
  "buddha.skill.desc.20": "Силки бьют сильнее и лучше проводят эффекты мантр.",
  "buddha.skill.desc.21": "Все выстрелы мантр наносят больше урона.",
  "buddha.skill.desc.22": "Первая случайная мантра на поле начинает сильнее.",
  "buddha.skill.desc.23": "Мантры быстрее ставятся, переносятся и заменяются.",
  "buddha.skill.desc.24": "Ступы чаще выпускают залпы мантр.",
  "buddha.skill.desc.25": "Ступы достают врагов с большего расстояния.",
  "buddha.skill.desc.26": "Метки прохождения дают дополнительную стартовую карму.",

  "buddha.hud.monk": "Монах Ур. {{level}}",
  "buddha.hud.karma": "Карма {{grace}}",
  "buddha.story.intro.panel1": "Колесо вращается. Держи переправы и не дай голодным теням добраться до ступицы.",
};
